export default __webpack_public_path__ + "Config/FsConfig.json?bust=b19bf6903a2d4f8f03641f9afe813a75";